import { render, staticRenderFns } from "./gTop.vue?vue&type=template&id=4ace3f1c&scoped=true&"
import script from "./gTop.vue?vue&type=script&lang=js&"
export * from "./gTop.vue?vue&type=script&lang=js&"
import style0 from "./gTop.vue?vue&type=style&index=0&id=4ace3f1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ace3f1c",
  null
  
)

export default component.exports